<template>
    <div class="flex flex-wrap justify-center mb-3 sm:mb-6">
        <div class="w-full">
            <div class="mb-5 sm:mb-3 text-center">
                <h4 class="m-0 font-bold sm:text-2xl" class2="sm:text-3xl">
                    <i v-if="group.icon" :class="group.icon" class="fad fa-lg mr-2 text-gray-700"></i>
                    {{ group.name }}
                    <!-- Trackers -->
                </h4>
            </div>

            <!-- <div class="flex flex-wrap items-center justify-center mb-3 sm:mb-6"> -->
            <div class="block mb-3 sm:mb-6">
                <!-- <category-card v-for="category in categories" :key="category.id" :category="category" /> -->
                <!-- <category-card :key="moreCategory.id" :category="moreCategory" /> -->
                <category-slider :categories="categories" />
            </div>
        </div>
    </div>
</template>

<script>
import forEach from 'lodash/forEach';

export default {
    props: ['group'],

    data: () => ({
        categories: [],
        moreCategory: {
            id: 'more',
            name: 'View More Categories',
            link: '/categories',
            image_url: null,
            icon: 'fa-list-alt'
        }
    }),

    created() {
        var categories = [];

        forEach(this.group.categories, (category, index) => {
            index++;

            // if (index % 5 === 0) {
            //     categories.push({
            //         name: 'ad'
            //     });
            // }

            categories.push(category);
        });

        this.categories = categories;
    },

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
